import React, { FC } from 'react';
import styled from 'src/theme';
import { Row, Col, Button, Tooltip} from 'antd';
import { Select, Option, InputNumber } from "src/components/UI";
import { QuestionCircleFilled } from '@ant-design/icons';

import { usePresenter } from './usePresenter';

export const CalculationsForm: FC = () => {

  const presenter = usePresenter();

  return (
    <>
      <Row gutter={[{ xs: 8, sm: 16, md: 32, lg: 64 }, 0]}>
        <Col xs={24}><TitleStyled>Параметры забора</TitleStyled></Col>

        <Col xs={24} xl={12}>
          <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, { xs: 8, sm: 8, md: 8 }]}>
            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled  xs={12} md={24}>
                  <LabelTextStyled>Длина, м</LabelTextStyled>
                  <Button icon={<Tooltip title='Общая длина забора без учета ворот и калиток'><QuestionCircleFilledStyled /></Tooltip>} type={'link'} />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <InputNumber
                    value={presenter.dzValue}
                    onChange={presenter.dzValueHandler}
                    style={{ width: '100%' }}
                    min={1}
                  />
                </Col>
              </Row>
            </Col>

            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Высота, м</LabelTextStyled>
                  <Button
                    icon={
                      <Tooltip title='Высота забора может быть от 1.5м до 2.2м. Другая высота возможна и рассчитывается индивидуально'>
                        <QuestionCircleFilledStyled />
                      </Tooltip>
                    }
                    type={'link'}
                  />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.vzValue}
                    onChange={presenter.vzValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="1.5">1.5м</Option>
                    <Option value="1.8">1.8м</Option>
                    <Option value="2">2м</Option>
                    <Option value="2.2">2.2м</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

          </Row>
        </Col>

        <Col xs={24} md={24} xl={12}>
          <Row>
            <ColumnLabelStyled xs={24}>
              <LabelTextStyled>Тип периметра</LabelTextStyled>
              <Button
                icon={
                  <Tooltip title='Замкнутый / Не замкнутый'>
                    <QuestionCircleFilledStyled />
                  </Tooltip>
                }
                type={'link'}
              />

            </ColumnLabelStyled>
            <Col xs={24}>
              <Select
                value={presenter.tpValue}
                onChange={presenter.tpValueHandler}
                style={{ width: '100%' }}
              >
                <Option value="Замкнутый">Замкнутый</Option>
                <Option value="Не замкнутый">Не замкнутый</Option>
              </Select>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[{ xs: 8, sm: 16, md: 32, lg: 64 }, 0]}>
        <Col xs={24}><TitleStyled>Параметры столбов</TitleStyled></Col>

        <Col xs={24} xl={12}>
          <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 0]}>
            <ColumnLabelStyled xs={24}>
              <LabelTextStyled>Расстояние между столбами, м</LabelTextStyled>
              <Button
                icon={
                  <Tooltip title='Для забора высотой более 2-х метров рекомендуется шаг столбов не более 2,5 м'>
                    <QuestionCircleFilledStyled />
                  </Tooltip>
                }
                type={'link'}
              />
            </ColumnLabelStyled>

            <Col xs={24}>
              <InputNumber
               value={presenter.rsValue}
               onChange={presenter.rsValueHandler}
               style={{ width: '100%' }}
               min={0.1}
              />
            </Col>
          </Row>
        </Col>

        <Col xs={24} xl={12}>
          <Row>
            <ColumnLabelStyled xs={24}><LabelTextStyled>Сечение</LabelTextStyled></ColumnLabelStyled>
            <Col xs={24}>
              <Select
                value={presenter.ssValue}
                onChange={presenter.ssValueHandler}
                style={{ width: '100%' }}
              >
                <Option value="50*50*2">50x50x2</Option>
                <Option value="60*40*2">60x40x2</Option>
                <Option value="60*60*2">60x60x2</Option>
                <Option value="Не нужно">Не нужно</Option>
              </Select>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[{ xs: 8, sm: 16, md: 32, lg: 64 }, 0]}>
        <Col xs={24} xl={12}>
          <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, { xs: 8, sm: 8, md: 8 }]}>
            <Col xs={24}><TitleStyled>Параметры ворот</TitleStyled></Col>

            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Количество</LabelTextStyled>
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.kvValue}
                    onChange={presenter.kvValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="0">0 шт.</Option>
                    <Option value="1">1 шт.</Option>
                    <Option value="2">2 шт.</Option>
                    <Option value="3">3 шт.</Option>
                    <Option value="4">4 шт.</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Ширина</LabelTextStyled>
                  <Button
                    icon={
                      <Tooltip title='Стандартная ширина ворот'>
                        <QuestionCircleFilledStyled />
                      </Tooltip>
                    }
                    type={'link'}
                  />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.shvValue}
                    onChange={presenter.shvValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="3.5">3.5м</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

          </Row>
        </Col>

        <Col xs={24} xl={12}>
          <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, { xs: 8, sm: 8, md: 8 }]}>
            <Col xs={24}><TitleStyled>Параметры калиток</TitleStyled></Col>

            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Количество</LabelTextStyled>
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.kkValue}
                    onChange={presenter.kkValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="0">0 шт.</Option>
                    <Option value="1">1 шт.</Option>
                    <Option value="2">2 шт.</Option>
                    <Option value="3">3 шт.</Option>
                    <Option value="4">4 шт.</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

            <Col xs={24} md={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Ширина</LabelTextStyled>
                  <Button
                    icon={
                      <Tooltip title='Стандартная ширина калитки'>
                        <QuestionCircleFilledStyled />
                      </Tooltip>
                    }
                    type={'link'}
                  />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.shkValue}
                    onChange={presenter.shkValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="0.9">0.9м</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[{ xs: 8, sm: 16, md: 32, lg: 64 }, { xs: 8, sm: 8, md: 8 }]}>
        <Col xs={24}><TitleStyled>Параметры горизонталей</TitleStyled></Col>

        <Col xs={24} xl={12}>
          <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, { xs: 8, sm: 8, md: 8 }]}>
            <Col xs={24} xl={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Вид</LabelTextStyled>
                  <Button icon={
                    <Tooltip title='Лага 40х20х2 крепится к столбам с помощью кронштейна,
                      крепежные профили шляпные (КПШ) крепятся к столбам напрямую самонарезающими винтами'
                    >
                      <QuestionCircleFilledStyled />
                    </Tooltip>
                  } type={'link'} />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.pgvValue}
                    onChange={presenter.pgvValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="40*20*1,5">40x20x1,5</Option>
                    <Option value="40*25*1,5">40x25x1,5</Option>
                    <Option value="Не нужно">Не нужно</Option>
                  </Select>
                </Col>
              </Row>
            </Col>

            <Col xs={24} xl={12}>
              <Row>
                <ColumnLabelStyled xs={12} md={24}>
                  <LabelTextStyled>Количество</LabelTextStyled>
                  <Button
                    icon={
                      <Tooltip title='Количество горизонтальных лаг в одном пролете между столбами. Чем больше лаг,
                        тем прочнее конструкция. Для забора до 2-х метров достаточно 2 лаги,
                        от 2-х до 2.5 м – рекомендуется установка 3-х лаг, свыше 2.5 м количество лаг определяется
                        расчетом на несущую способность'
                      >
                        <QuestionCircleFilledStyled />
                      </Tooltip>
                    }
                    type={'link'}
                  />
                </ColumnLabelStyled>

                <Col xs={12} md={24}>
                  <Select
                    value={presenter.pgkValue}
                    onChange={presenter.pgkValueHandler}
                    style={{ width: '100%' }}
                  >
                    <Option value="2">2 ряда</Option>
                    <Option value="3">3 ряда</Option>
                    <Option value="0">Не нужны</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <ColumnFlexEndStyled xs={24} xl={12}>
          <Row>
            <ColumnLabelStyled xs={12} md={24}>
              <LabelTextStyled>Крепления</LabelTextStyled>
            </ColumnLabelStyled>

            <Col xs={24}>
              <Select
                value={presenter.kValue}
                onChange={presenter.kValueHandler}
                style={{ width: '100%' }}
              >
                <Option value="Саморез 4,8х19">Саморез 4,8х19</Option>
              </Select>
            </Col>
          </Row>
        </ColumnFlexEndStyled>
      </Row>
    </>
  );
};

const ColumnLabelStyled = styled(Col)`
  display: flex;
  min-height: 32px;
  align-items: center;
`;

const LabelTextStyled = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #000000;
`;

const QuestionCircleFilledStyled = styled(QuestionCircleFilled)`
  font-size: 18px;
  color: ${props => props.theme.colors.orange}
`;

const TitleStyled = styled.h4`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.01em;
  color: #212121;
  text-transform: uppercase;
  margin: 28px 0 2px;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    margin: 28px 0 12px;
  }
`;

const ColumnFlexEndStyled = styled(Col)`
  display: flex;
  align-items: flex-end;
  .ant-row {
    width: 100%;
  }
`;
